import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { ff } from '@atlassian/jira-feature-flagging';

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TableCellFocusBox = styled.div(
	{
		border: 'none',
		'&:focus-within': {
			borderRadius: '3px',
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
			boxShadow: `inset 0 0 0 2px ${token('color.border.focused', colors.B200)}`,
		},
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
		'a:focus': {
			outline: 'none',
		},
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	() =>
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
		ff('jsv-one-issue-table-spreadsheet-ui_ygrnf')
			? {
					marginBlock: token('space.negative.050', '-4px'),
					marginInline: token('space.negative.100', '-8px'),
					paddingBlock: token('space.050', '4px'),
					paddingInline: token('space.100', '8px'),
				}
			: {
					margin: token('space.negative.100', '-8px'),
					padding: token('space.100', '8px'),
				},
);
